import React, { useState, useEffect, useRef } from 'react';
import { elevacionEnDistancia } from '../utils/map';
import AltimetriaChart from '../components/AltimetriaChart';
import { PERFIL_ELEVACION_MOCK } from '../mocks/altimetriaMock';

const TOP_N = 3;
const RESPAWN_MS = 3000;

const RUNNERS_POOL = [
  { dorsal: 101, porcentaje: 62, velocidad: 0.045, finished: false },
  { dorsal: 205, porcentaje: 60, velocidad: 0.030, finished: false },
  { dorsal: 89, porcentaje: 45, velocidad: 0.090, finished: false },
  { dorsal: 314, porcentaje: 30, velocidad: 0.150, finished: false }
];

function AltimetriaLEDMockScreen() {
  const [runners, setRunners] = useState(RUNNERS_POOL);
  const intervalRef = useRef(null);
  const respawnTimeoutsRef = useRef({});

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setRunners(prev => prev.map(r => {
        if (r.finished) return r;

        let porcentaje = r.porcentaje + r.velocidad;

        if (porcentaje >= 100) {
          if (!respawnTimeoutsRef.current[r.dorsal]) {
            respawnTimeoutsRef.current[r.dorsal] = setTimeout(() => {
              setRunners(current => current.map(x =>
                x.dorsal === r.dorsal ? { ...x, porcentaje: 0, finished: false } : x
              ));
              delete respawnTimeoutsRef.current[r.dorsal];
            }, RESPAWN_MS);
          }
          return { ...r, porcentaje: 100, finished: true };
        }

        return { ...r, porcentaje };
      }));
    }, 250);

    return () => {
      clearInterval(intervalRef.current);
      Object.values(respawnTimeoutsRef.current).forEach(clearTimeout);
    };
  }, []);

  const totalKm = PERFIL_ELEVACION_MOCK[PERFIL_ELEVACION_MOCK.length - 1].distanciaKm;

  // Igual que en la pantalla real: cuenta a los ya terminados para
  // desplazar la numeracion de quien sigue corriendo.
  const finishedCount = runners.filter(r => r.finished).length;

  const primeros = runners
    .filter(r => !r.finished)
    .sort((a, b) => b.porcentaje - a.porcentaje)
    .slice(0, TOP_N)
    .map((r, idx) => ({
      dorsal: r.dorsal,
      porcentaje: r.porcentaje,
      position: finishedCount + idx + 1,
      elevacion: elevacionEnDistancia(PERFIL_ELEVACION_MOCK, (r.porcentaje / 100) * totalKm)
    }));

  return (
    <div className="w-screen h-screen bg-black">
      <AltimetriaChart perfilElevacion={PERFIL_ELEVACION_MOCK} primeros={primeros} />
    </div>
  );
}

export default AltimetriaLEDMockScreen;
